import React from 'react';
import config from 'config/default';
import { usePortal } from 'context';

const ScheduleButton = () => {
    const {
        user: { partnerAccent },
    } = usePortal();

    return (
        <section className="subheader-item">
            <a
                className="subheader-button"
                href={`${config.viewlogiesClientUrl}/download`}
                target="_blank"
                rel="noopen noreferrer"
            >
                <h2 style={{ color: partnerAccent ? partnerAccent : undefined }}>{'Download'}</h2>
            </a>
        </section>
    );
};

export default ScheduleButton;
